import {bindable, customElement} from "aurelia-framework";

@customElement('crate-product-section')
export class CrateProductSection {
  @bindable() product;
  @bindable() imgAlign;
}
